module.exports = {
	"config": {
		"black": "#111111",
		"blackest": "#000000",
		"white": "#ffffff",
		"url": "https://ghni.com",
		"name": "Greater Houston Neurological Institute",
		"legal_name": "Greater Houston Neurological Institute",
		"logo": "",
		"email": "info@ghni.com",
		"phone_number": "",
		"address_city": "",
		"address_state": "",
		"address_zipcode": "",
		"address_street": "",
		"address_area": "",
		"twitter": "",
		"twitter_id": "",
		"default_title": "GHNI | Lonestar Seminar Survey",
		"default_description": "Greater Houston Neurological Institute is expanding. Join the GHNI Network."
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.js",
				"ext": "js",
				"name": "_template",
				"extname": ".js",
				"basename": "_template.js",
				"dirname": "",
				"stem": "_template",
				"path": "_template.js",
				"absolute": "/Users/gary/Code/ghni-seminar/_template.js",
				"isAbsolute": false
			},
			"requirePath": "_template.js",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "es.js",
				"ext": "js",
				"name": "es",
				"extname": ".js",
				"basename": "es.js",
				"dirname": "",
				"stem": "es",
				"path": "es.js",
				"absolute": "/Users/gary/Code/ghni-seminar/es.js",
				"isAbsolute": false
			},
			"requirePath": "es.js",
			"path": "/es/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "",
				"stem": "index",
				"path": "index.js",
				"absolute": "/Users/gary/Code/ghni-seminar/index.js",
				"isAbsolute": false
			},
			"requirePath": "index.js",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "survey/form",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "survey/form",
				"stem": "index",
				"path": "survey/form/index.js",
				"absolute": "/Users/gary/Code/ghni-seminar/survey/form/index.js",
				"isAbsolute": false
			},
			"requirePath": "survey/form/index.js",
			"path": "/survey/form/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "survey",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "survey",
				"stem": "index",
				"path": "survey/index.js",
				"absolute": "/Users/gary/Code/ghni-seminar/survey/index.js",
				"isAbsolute": false
			},
			"requirePath": "survey/index.js",
			"path": "/survey/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "survey/questions",
				"base": "Question1.js",
				"ext": "js",
				"name": "Question1",
				"extname": ".js",
				"basename": "Question1.js",
				"dirname": "survey/questions",
				"stem": "Question1",
				"path": "survey/questions/Question1.js",
				"absolute": "/Users/gary/Code/ghni-seminar/survey/questions/Question1.js",
				"isAbsolute": false
			},
			"requirePath": "survey/questions/Question1.js",
			"path": "/survey/questions/Question1/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "survey/questions",
				"base": "Question2.js",
				"ext": "js",
				"name": "Question2",
				"extname": ".js",
				"basename": "Question2.js",
				"dirname": "survey/questions",
				"stem": "Question2",
				"path": "survey/questions/Question2.js",
				"absolute": "/Users/gary/Code/ghni-seminar/survey/questions/Question2.js",
				"isAbsolute": false
			},
			"requirePath": "survey/questions/Question2.js",
			"path": "/survey/questions/Question2/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "survey/questions",
				"base": "Question3.js",
				"ext": "js",
				"name": "Question3",
				"extname": ".js",
				"basename": "Question3.js",
				"dirname": "survey/questions",
				"stem": "Question3",
				"path": "survey/questions/Question3.js",
				"absolute": "/Users/gary/Code/ghni-seminar/survey/questions/Question3.js",
				"isAbsolute": false
			},
			"requirePath": "survey/questions/Question3.js",
			"path": "/survey/questions/Question3/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "survey/questions",
				"base": "Question4.js",
				"ext": "js",
				"name": "Question4",
				"extname": ".js",
				"basename": "Question4.js",
				"dirname": "survey/questions",
				"stem": "Question4",
				"path": "survey/questions/Question4.js",
				"absolute": "/Users/gary/Code/ghni-seminar/survey/questions/Question4.js",
				"isAbsolute": false
			},
			"requirePath": "survey/questions/Question4.js",
			"path": "/survey/questions/Question4/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "survey/questions",
				"base": "Question5.js",
				"ext": "js",
				"name": "Question5",
				"extname": ".js",
				"basename": "Question5.js",
				"dirname": "survey/questions",
				"stem": "Question5",
				"path": "survey/questions/Question5.js",
				"absolute": "/Users/gary/Code/ghni-seminar/survey/questions/Question5.js",
				"isAbsolute": false
			},
			"requirePath": "survey/questions/Question5.js",
			"path": "/survey/questions/Question5/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "survey/questions",
				"base": "Submitting.js",
				"ext": "js",
				"name": "Submitting",
				"extname": ".js",
				"basename": "Submitting.js",
				"dirname": "survey/questions",
				"stem": "Submitting",
				"path": "survey/questions/Submitting.js",
				"absolute": "/Users/gary/Code/ghni-seminar/survey/questions/Submitting.js",
				"isAbsolute": false
			},
			"requirePath": "survey/questions/Submitting.js",
			"path": "/survey/questions/Submitting/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "thank-you",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "thank-you",
				"stem": "index",
				"path": "thank-you/index.js",
				"absolute": "/Users/gary/Code/ghni-seminar/thank-you/index.js",
				"isAbsolute": false
			},
			"requirePath": "thank-you/index.js",
			"path": "/thank-you/",
			"data": {}
		}
	]
}


/*****************
 ** WEBPACK FOOTER
 ** ../config.toml
 ** module id = 389
 ** module chunks = 0
 **/